module.exports = __webpack_public_path__ + "static/media/SF-Pro-Text-Regular.889036a2.otf";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/SF-Pro-Text-Regular.otf
// module id = 1660
// module chunks = 0